import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QueryOptions, useQuery } from '@globalconnect/query';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { RolloutProgressReportEntities } from '../entities';
import { rpReportDefinitionsKey } from '../entities/query-keys';
import { RolloutProgressReportDefinitionsApiService } from './api/rollout-progress-report-definitions-api.service';

@Injectable({
  providedIn: 'root',
})
export class RolloutProgressReportDefinitionsService {
  storedDefinitions$ = new BehaviorSubject<
    Record<
      RolloutProgressReportEntities.v3.MarkerTypes,
      RolloutProgressReportEntities.v3.DefinitionsWithGroupInfoResponse
    >
  >(
    {} as Record<
      RolloutProgressReportEntities.v3.MarkerTypes,
      RolloutProgressReportEntities.v3.DefinitionsWithGroupInfoResponse
    >,
  );

  constructor(private apiService: RolloutProgressReportDefinitionsApiService) {}

  getDefinitions$(
    pointType: RolloutProgressReportEntities.v3.MarkerTypes,
    options?: Partial<
      QueryOptions<
        RolloutProgressReportEntities.v3.DefinitionsWithGroupInfoResponse,
        HttpErrorResponse,
        never,
        RolloutProgressReportEntities.v3.DefinitionsWithGroupInfoResponse
      >
    >,
  ) {
    return useQuery(
      [rpReportDefinitionsKey, pointType],
      () => this.apiService.getDefinitions(pointType),
      {
        onSuccess: (definitions) =>
          this.setStoredDefinitions(pointType, definitions),
        onError: () => console.error('error'),
        ...options,
      },
    ).getState$();
  }

  setStoredDefinitions = (
    pointType: RolloutProgressReportEntities.v3.MarkerTypes,
    definitions: RolloutProgressReportEntities.v3.DefinitionsWithGroupInfoResponse,
  ): void => {
    this.storedDefinitions$.next({
      ...this.storedDefinitions$.getValue(),
      [pointType]: definitions,
    });
  };

  getStoredDefinitionsByPointType$ = (
    pointType: RolloutProgressReportEntities.v3.MarkerTypes,
  ): Observable<RolloutProgressReportEntities.v3.DefinitionsWithGroupInfoResponse> =>
    this.storedDefinitions$.pipe(map((report) => report[pointType]));
}
